module.exports = "https://web-assets.ifttt.com/packs/media/home/explore_applets_button-3cb59f66.png";